import React, { useContext, useEffect, useState } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import Loading from "../containers/Loading";
import { AuthContext } from "../auths/Auth";
import PrivateLayout from "../layouts/PrivateLayout";
import localforage from "localforage";
import LoginErrorPage from "../containers/LoginError";

import _ from "lodash";
import CommonLayout from "@/layouts/CommonLayout";

const PrivateRoute = ({ component: Component, ...props }) => {
  // Declare the useContext() so this component will have the same context as AuthContext.Provider
  const { isAuthenticated, isLoading, checkAuth, isLoginFailed } =
    useContext(AuthContext);
  const permissionName = props.permissionName;
  const showToolBar = props.showToolBar;
  const hideFooter = props.hideFooter;
  const useCommonLayout = props.useCommonLayout;
  const [isPermitted, setIsPermitted] = useState(
    !permissionName ? true : false
  );

  const checkIsPermitted = async permissionName => {
    if (!permissionName) {
      setIsPermitted(true);
      return true;
    }
    // check if the user is permitted
    const userPermissionsArray = await localforage.getItem("userPermissions");
    // console.log("userPermissionsArray", userPermissionsArray);
    if (
      permissionName !== "No Permission" &&
      permissionName !== "Home" &&
      userPermissionsArray &&
      userPermissionsArray.includes(permissionName)
    ) {
      setIsPermitted(true);
      return true;
    }
    if (permissionName === "No Permission" || permissionName === "Home") {
      setIsPermitted(true);
      return true;
    }
    setIsPermitted(false);
    return false;
  };

  useEffect(() => {
    checkAuth("route");
    checkIsPermitted(permissionName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, permissionName]);
  return (
    <Route
      {...props}
      render={props => {
        if (isLoading) {
          return <Loading />;
        }

        if (!isAuthenticated) {
          return isLoginFailed ? (
            <Redirect to="/login-error" />
          ) : (
            <Redirect to="/login" />
          );
        }

        if (!isPermitted) {
          return <Redirect to="/no-permission" />;
        }

        const Layout = useCommonLayout ? CommonLayout : PrivateLayout;

        return (
          <Layout showToolBar={showToolBar} hideFooter={hideFooter} {...props}>
            <Component {...props} />
          </Layout>
        );
      }}
      name={props.permissionName}
    />
  );
};

export default PrivateRoute;
